















































import { deepEqual } from '@empathybroker/deep-equal';
import { AuditObjectTypeEnum } from '@empathybroker/tsclient-play/dist/enums/audit-object-type.enum';

import { AuditDetailField } from '../../../models';

import { ArrayUtils } from '../../../utils';

export default {
  name: 'audit-details',
  props: {
    audit: {
      type: Object,
      required: true
    },
    ignoredFields: {
      type: Array,
      default: () => ['meta', 'filters', 'pivots']
    },
    messages: {
      type: Object,
      required: true
    }
  },
  computed: {
    fields: function (): AuditDetailField[] {
      return this.getLevelFields(this.audit.payload.previousState, this.audit.payload.nextState);
    }
  },
  methods: {
    getLevelFields: function (previousValue: any = {}, nextValue: any = {}, level = 0): AuditDetailField[] {
      const fieldIds = ArrayUtils.union(Object.keys(previousValue), Object.keys(nextValue));
      return fieldIds.reduce((fields: AuditDetailField[], fieldId: string) => {
        const isParent = (this.isObject(previousValue[fieldId]) || this.isObject(nextValue[fieldId]));
        const isFieldIgnored = this.ignoredFields.includes(fieldId);
        if (!isFieldIgnored) {
          fields.push({
            id: fieldId,
            ...(!isParent && {
              previousValue: previousValue[fieldId],
              nextValue: nextValue[fieldId]
            }),
            level: level,
            isParent: isParent
          });
        }
        if (isParent) {
          const childFields = this.getLevelFields(previousValue[fieldId], nextValue[fieldId], (isFieldIgnored ? level : level + 1));
          fields = fields.concat(childFields);
        }
        return fields;
      }, []);
    },
    getFieldName: function (fieldId: string): string {
      fieldId = fieldId.split('.').pop();
      const toolsMessages = this.$epb.messages.tools;
      const toolMessages = {
        [AuditObjectTypeEnum.EQUALIZE]: toolsMessages.equalize,
        [AuditObjectTypeEnum.BLACKLIST]: toolsMessages.blacklist,
        [AuditObjectTypeEnum.PRODUCTS_RANKING]: toolsMessages.productsRanking,
        [AuditObjectTypeEnum.ATTRIBUTES_RANKING]: toolsMessages.attributesRanking,
        [AuditObjectTypeEnum.PROMOTION]: toolsMessages.promotions,
        [AuditObjectTypeEnum.REDIRECTION]: toolsMessages.redirections,
        [AuditObjectTypeEnum.SYNONYM]: toolsMessages.synonyms,
        [AuditObjectTypeEnum.BROWSE_CONFIGURATION]: toolsMessages.configurations,
        [AuditObjectTypeEnum.SEARCH_CONFIGURATION]: toolsMessages.configurations,
        [AuditObjectTypeEnum.INSTANCE]: toolsMessages.instances
      }[this.audit.payload.objectType];
      if (!!toolMessages) {
        const fieldMessages = toolMessages.fields[fieldId];
        if (!!fieldMessages) {
          return fieldMessages.label;
        }
      }
      return fieldId;
    },
    getFieldValueText: function (fieldValue): string {
      if (Array.isArray(fieldValue)) {
        return fieldValue.map(this.getFieldValueText).join(', ');
      } else if (fieldValue instanceof Date) {
        // @ts-ignore : https://github.com/microsoft/TypeScript/issues/34399
        return fieldValue.toLocaleDateString(this.$epb.locale, { hourCycle: 'h23', hour: '2-digit', minute: '2-digit' });
      } else if (this.isObject(fieldValue)) {
        return JSON.stringify(fieldValue);
      } else {
        return fieldValue;
      }
    },
    isFieldModified: function (field: AuditDetailField): boolean {
      if (field.previousValue instanceof Date && field.nextValue instanceof Date) {
        return (field.previousValue.getTime() !== field.nextValue.getTime());
      }
      return !deepEqual(field.previousValue, field.nextValue);
    },
    isObject: function (value: any): boolean {
      return (!!value && (typeof value === 'object') && !(value instanceof Array) && !(value instanceof Date));
    }
  }
};
